var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgAlert = function SvgAlert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.083,
    y: 5.5,
    width: 1.83333,
    height: 7.33333,
    rx: 0.916667,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 14.4375C11.6332 14.4375 12.1462 14.9505 12.1462 15.5833C12.1462 16.2162 11.6332 16.7292 11.0003 16.7292C10.3675 16.7292 9.85449 16.2162 9.85449 15.5833C9.85449 14.9505 10.3675 14.4375 11.0003 14.4375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1663 11.0002C20.1663 16.0628 16.0623 20.1668 10.9997 20.1668C5.93706 20.1668 1.83301 16.0628 1.83301 11.0002C1.83301 5.93755 5.93706 1.8335 10.9997 1.8335C16.0623 1.8335 20.1663 5.93755 20.1663 11.0002ZM3.66634 11.0002C3.66634 15.0503 6.94959 18.3335 10.9997 18.3335C15.0498 18.3335 18.333 15.0503 18.333 11.0002C18.333 6.95007 15.0498 3.66683 10.9997 3.66683C6.94959 3.66683 3.66634 6.95007 3.66634 11.0002Z",
    fill: "currentColor"
  })));
};
export default SvgAlert;